import { activitiesService } from "@/apis/services"
import { IActivity, IPaginationMeta, IPaginationParamV2 } from "@/types"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface IActivityState {
  activities: IActivity[]
  meta?: IPaginationMeta
  isLoading: boolean
  error: string | null
  fetchActivities: (params: IPaginationParamV2) => Promise<void>
}

const initialState = {
  activities: [],
  meta: undefined,
  isLoading: false,
  error: null,
}

export const useActivitiesStore = create<IActivityState>()(
  devtools(set => ({
    ...initialState,

    fetchActivities: async (params: IPaginationParamV2) => {
      set({ isLoading: true, error: null })
      try {
        const response = await activitiesService.getActivities(params)
        set({ activities: response.data.items, meta: response.data.meta })
      } catch (error) {
        const errorMessage: string = error instanceof Error ? error.message : "An unknown error occurred"
        set({ error: errorMessage })
        throw error
      } finally {
        set({ isLoading: false })
      }
    },
  }))
)
